/**
 * Converts an app URL stored for browser/push navigation into the path Vue
 * Router expects when the application itself is mounted below a base path.
 */
export function routeForRouter(route, base = '') {
  if (!route || !base) return route

  const normalizedBase = base.replace(/\/$/, '')
  if (route === normalizedBase) return '/'
  if (route.startsWith(`${normalizedBase}/`)) return route.slice(normalizedBase.length)
  return route
}
